import {CustomList} from "./CustomList";
import {CustomEdit} from "./CustomEdit";
import {CustomCreate} from "./CustomCreate";

export default {
    list: CustomList,
    create: CustomCreate,
    edit: CustomEdit
};
